export default {"src":"/hedera/_next/static/media/sun_dark.90387a0d.svg","height":16,"width":16};